import ResidentContingencyPlans from 'screens/Residents/screens/ResidentProfileScreen/screens/ResidentContingencyPlans/ResidentContingencyPlans'
import { ID } from '../utils'
import { Route } from 'react-router-dom'
import AddContingencyPlan from 'screens/Residents/screens/ResidentProfileScreen/screens/ResidentContingencyPlans/AddContingencyPlan'
import ViewEditContingencyPlan from 'screens/Residents/screens/ResidentProfileScreen/screens/ResidentContingencyPlans/ViewEditContingencyPlan'

const ADD = 'add'
const VIEW_EDIT = ':contingencyPlanID'
export const contingencyPlansRoutes = (
  <Route path={`${ID}/contingency-plans`}>
    <Route index path="" element={<ResidentContingencyPlans />} />
    <Route path={ADD} element={<AddContingencyPlan />} />
    <Route path={VIEW_EDIT} element={<ViewEditContingencyPlan />} />
  </Route>
)
